import { render, staticRenderFns } from "./activityCourseQuiz.html?vue&type=template&id=4dac48a6&scoped=true&external"
import script from "./activityCourseQuiz.vue?vue&type=script&lang=js"
export * from "./activityCourseQuiz.vue?vue&type=script&lang=js"
import style0 from "./activityCourseQuiz.css?vue&type=style&index=0&id=4dac48a6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dac48a6",
  null
  
)

export default component.exports